import BackButton from 'components/backButton'
import { Button, Spinner } from 'components/common'
import { CreateFocRmaModal } from 'components/focOrderManagement'
import FocOrderDetailsSection from 'components/focOrderManagement/focOrderDetailSection'
import { usePageAccess, useSafeBack } from 'hooks'
import useModal from 'hooks/useModal'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate, useParams } from 'react-router-dom'
import { FocOrder } from 'types/foc'
import { fetchFocOrder } from 'utils/api/focApi'
import { PAGE_FOC_ORDER_LIST, PAGE_NOT_FOUND } from 'utils/constants'

const ORDER_NO = 'orderNo'

const FocOrderDetailsPage = () => {
  const navigate = useNavigate()
  const { orderId: orderNo } = useParams()

  const [focOrder, setFocOrder] = useState<FocOrder>()
  const [loading, setLoading] = useState<boolean>(true)
  const [refetch, setRefetch] = useState<boolean>(false)

  const { isEditor } = usePageAccess()

  const getFocOrderDetails = async (orderId: string) => {
    try {
      const { data } = await fetchFocOrder(orderId)
      setFocOrder({ ...data })
    } catch (error) {
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (orderNo) {
      getFocOrderDetails(orderNo)
    }
  }, [refetch])

  const { closeModal, isOpen, openModal } = useModal()

  const redirectToOrdersPage = useSafeBack(PAGE_FOC_ORDER_LIST.path)

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Foc Order Detail </title>
      </Helmet>

      {isEditor && (
        <CreateFocRmaModal
          onSuccess={() => {
            setRefetch(!refetch)
          }}
          orderId={focOrder!._id}
          orderNo={orderNo!}
          closeModal={closeModal}
          isOpen={isOpen}
        />
      )}

      <div className="flex items-center justify-between">
        <BackButton handleBack={redirectToOrdersPage} />

        {isEditor && !focOrder?.rma.isFullRmaCreated && (
          <div className="flex items-center justify-end gap-2">
            <Button
              buttonText="Revert"
              type="button"
              onClick={() => openModal()}
            />
          </div>
        )}
      </div>

      {focOrder && ORDER_NO in focOrder && (
        <>
          <FocOrderDetailsSection order={focOrder} />
        </>
      )}
    </>
  )
}

export default FocOrderDetailsPage
